var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: _vm.titulo }, on: { cerrar: _vm.handleCerrar } },
        [_vm._t("default")],
        2
      ),
      _c("Confirmation", {
        attrs: {
          show: _vm.showConfirmacionCerrar,
          titulo: _vm.tituloConfirmacion,
          mensaje: _vm.cuerpoConfirmacion,
          textoBtnSi: _vm.textoBtnAceptar,
          textoBtnNo: _vm.textoBtnCancelar
        },
        on: { modalConfirmationEmit: _vm.handleConfirmarCerrar }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }